<template>
  <TransitionRoot appear :show="isChildOpen" as="template">
    <Dialog as="div">
      <div class="fixed inset-0 overflow-y-auto" style="z-index: 310">
        <div class="min-h-screen px-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div>
              <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
              <div
                style="width: 888px;
                      height: 568px;
                      max-height: 568px;
                      position: fixed;
                      top: 50%;
                      left: 50%;
                      transform: translate(calc(-50% + 12px), calc(-50% + 12px));
                      border-radius: 24px 0px 24px 24px;"
              ></div>
            </div>
          </TransitionChild>
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              style="width: 888px; height: 568px; top: 50%;left: 50%;border-radius: 24px 0px 24px 24px; z-index: 401; position: fixed; transform: translate(-50%, -50%);"
              :class="
                `inline-block overflow-hidden text-left align-middle transition-all transform`
              "
            >
              <DialogTitle
                as="template"
                style="height: 58px; background: #e4f1f9 !important;"
                class="border-b-4 flex flex-row items-center"
                :class="`border-${color}`"
              >
                <div>
                  <slot name="dialogTitle"></slot>
                  <close-icn
                    fill="green"
                    width="20"
                    height="20"
                    class="fixed top-0 right-0 mt-4 mr-5"
                    @click="cancel"
                  />
                </div>
              </DialogTitle>
              <div
                class="flex flex-col justify-between"
                style="height: 510px; max-height: 510px; background: #e4f1f9;"
              >
                <div style="overflow: hidden;">
                  <slot name="dialogContent"></slot>
                </div>
                <div
                  :class="
                    `flex flex-row items-center justify-center h-12 rounded-full mx-1 my-1 border-4 border-blue bg-blue`
                  "
                  style="z-index:10;"
                >
                  <button
                    :class="
                      `flex flex-row items-center justify-center text-center box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black rounded-full`
                    "
                    style="width:512px;"
                    type="submit"
                    v-bind="$attrs"
                    @click="validate"
                  >
                    <div class="flex flex-row items-center justify-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-1"
                      >
                        <circle cx="11" cy="11" r="10.5" stroke="#2993CE" />
                        <path
                          d="M15 4.07175C14.0434 3.51947 12.8202 3.84722 12.2679 4.8038L7.76793 12.598L11.232 14.598L15.732 6.8038C16.2843 5.84722 15.9566 4.62403 15 4.07175Z"
                          fill="#2993CE"
                        />
                        <path
                          d="M7.48232 18.0212C7.12762 18.3003 6.61387 18.0037 6.67824 17.557L7.26793 13.4641L10.732 15.4641L7.48232 18.0212Z"
                          fill="#2993CE"
                        />
                      </svg>
                      <div class="flex flex-row items-baseline">
                        <span
                          :class="
                            `text-${color} text-lg font-bold leading-tight`
                          "
                        >
                          経費
                        </span>
                        <span
                          :class="
                            `text-${color} text-sm font-bold leading-tight`
                          "
                          >を</span
                        >
                        <span
                          :class="
                            `text-${color} text-lg font-bold leading-tight`
                          "
                        >
                          追加
                        </span>
                        <span
                          :class="
                            `text-${color} text-sm font-bold leading-tight`
                          "
                        >
                          する
                        </span>
                      </div>
                    </div>
                  </button>
                  <slot name="dialogFooterActions"></slot>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { useDialog } from '@/services/useDialog'
import { useMemoryItemForm } from '@/services/politicalActionToda/useMemoryItemForm'
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
  DialogTitle,
} from '@headlessui/vue'
import closeIcn from '@/assets/icons/close.svg?inline'

export default {
  name: 'AppChildDialog',

  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
    closeIcn,
  },

  props: {
    color: String,
    bgColor: {
      type: String,
      default: 'white',
    },
  },

  setup() {
    const { isChildOpen } = useDialog()
    const { closeChildDialog } = useDialog()

    const cancel = () => {
      const { initMemoryItemForm } = useMemoryItemForm()
      initMemoryItemForm()
      closeChildDialog()
    }

    const commitCurrentPoliticalAction = () => {
      const { mergeExpenses } = useMemoryItemForm()
      mergeExpenses()
      closeChildDialog()
    }

    const validate = () => {
      const a = document.getElementById('memory-validate-toda')
      a.click()
    }
    return {
      isChildOpen,
      commitCurrentPoliticalAction,
      cancel,
      validate,
      ...usePoliticalActionDialog(),
    }
  },
}
</script>
<style lang="scss"></style>
